module.exports = __webpack_public_path__ + "img/blueInfo.9c004f07.svg";